export default [
    {
        component: () => import(/* webpackChunkName: 'ambulatorio-supervisor' */ '@/views/ambulatorio/supervisor/Index'),
        path: 'supervisor',
        redirect: 'supervisor/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'ambulatorio-supervisor' */'@/views/ambulatorio/supervisor/List.vue'),
                name: 'ambulatorio-supervisor-index',
                path: 'index',
            },
            {
                component: () => import(/* webpackChunkName: 'ambulatorio-supervisor' */ '@/views/ambulatorio/supervisor/Form.vue'),
                name: 'ambulatorio-supervisor-create',
                path: 'create',
            },
            {
                component: () => import(/* webpackChunkName: 'ambulatorio-supervisor' */ '@/views/ambulatorio/supervisor/Form.vue'),
                name: 'ambulatorio-supervisor-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
            },
        ],
    },
]